<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type" style="width:520px;">
					<AC ref="ac" :source="selectACItems" @selected="selectACItem" results-display="code_name" placeholder="Item / Name or ID"> </AC>
				</span>
				<span class="mgr_5"> <CustomDatePicker v-model="date_from"/> ~ <CustomDatePicker v-model="date_to"/></span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
			<div class="left_option" style="padding-top:2px;">
				<em class="lt_text">Item Code</em>
				<span class="int_type" style="width:120px;">
					<input type="text" v-model.trim="item_code" readonly autocomplete="off" />
				</span>
				<em class="lt_text">Name</em>
				<span class="int_type" style="width:600px;">
					<input type="text" v-model.trim="item_name" readonly autocomplete="off" />
				</span>
			</div>
		</div>

		<table class="list_tbl">
			<thead>
				<tr>
					<th style="width: 180px;">
						<a href="javascript:;" @click="sort('crt_dt')">Datetime{{ sortMark('crt_dt') }}</a>
					</th>
					<th style="width: 250px;">Item Code</th>
					<th>Item Name</th>
					<th style="width: 100px;">Before</th>
					<th style="width: 100px;">Change</th>
					<th style="width: 100px;">After</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="history in histories" v-bind:key="history.inventory_no">
					<td class="al_left">{{ history.crt_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
					<td class="al_left">{{ history.item_code }}</td>
					<td class="al_left truncate">{{ history.item_name }}</td>
					<td class="al_right">{{ history.before_quantity | commaSeparated }}</td>
					<td class="al_right">{{ history.diff_quantity | commaSeparated }}</td>
					<td class="al_right">{{ history.after_quantity | commaSeparated }}</td>
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<li><a href="javascript:void(0);" v-on:click="excel">Excel</a></li>
				<li><a href="javascript:void(0);" v-on:click="print">Print</a></li>
			</ul>
		</div>
	</div>
</template>

<script>
//import { today, daysAgo } from '@/utils/date';
import { today } from '@/utils/date';
import moment from 'moment';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectItem } from '@/api/item/master.js';
import { apiSelectInventoryHistoryList } from '@/api/item/inventory.js';
import AC from '@/components/common/AC';
import { exportDataExcel, reportMrtUrl, reportRender } from '@/api/util';
import { defaultDataType } from 'export-xlsx';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,
			active_only: true,

			date_from: null,
			date_to: today(),
			item_id: null,
			item_name: null,
			item_code: null,
			class_code: null,
			color_code: null,
			adjust_reason: 'repack',

			histories: [],

			modalName: '',
			showModal: false,

			sort_key: null,
			sort_direction: 'ASC',
		};
	},
	props: ['headers'],
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		AC,
	},
	methods: {
		async getData() {
			const { data } = await apiSelectInventoryHistoryList({
				paging_yn: 'N',
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				item_id: this.item_id,
				date_from: this.date_from,
				date_to: this.date_to,
				adjust_reason: this.adjust_reason,
			});

			return data;
		},

		async print() {
			const data = await this.getData();

			data.date_from = this.date_from;
			data.date_to = this.date_to;
			data.by = this.user.user_id;

			await reportRender(data, 'InventoryAdjustmentReportForRepacking', reportMrtUrl('InventoryAdjustmentForRepacking'));
			//console.log(data);
		},
		async excel() {
			const data = await this.getData();

			//var vm = this;
			let histories_for_excel = data.inventoryHistoryList;
			histories_for_excel.forEach(h => {
				h.crt_dt_local = moment(h.crt_dt).format('MM-DD-YYYY HH:mm:ss');
			});

			let fileName = 'InventoryAdjustmentReportForRepacking';
			if (this.date_from) fileName += '_' + this.date_from;
			if (this.date_to) fileName += '_' + this.date_to;

			let headers = [
				{ key: 'crt_dt_local', name: 'Datetime', width: 20, dataType: defaultDataType.string },
				{ key: 'item_code', name: 'Item Code', width: 45, dataType: defaultDataType.string },
				{ key: 'item_name', name: 'Item Name', width: 100, dataType: defaultDataType.string },
				{ key: 'before_quantity', name: 'Before', width: 10, dataType: defaultDataType.currency },
				{ key: 'diff_quantity', name: 'Change', width: 10, dataType: defaultDataType.currency },
				{ key: 'after_quantity', name: 'After', width: 10, dataType: defaultDataType.currency },
			];

			exportDataExcel(histories_for_excel, headers, fileName);
		},
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectInventoryHistories();
			//console.log(sort_key);
		},
		selectACItems(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_master/acItemList?company_id=' + this.user.company_id + '&active_only=' + this.active_only + '&keyword=' + input;
			return url;
		},
		selectACItem(i) {
			this.item_id = i.selectedObject.item_id;
			this.search();
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectInventoryHistories(pageNo);
		},
		reset() {
			this.item_id = null;
			this.item_name = null;
			this.item_code = null;
			this.color_code = null;
			this.class_code = null;

			this.date_from = null;
			this.date_to = today();
			this.adjust_reason = null;

			//this.selectInvoices();
			// this.dept_code = null;
		},
		search() {
			this.selectInventoryHistories();
		},
		async selectInventoryHistories(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			// if (!this.item_id && (!this.date_from || !this.date_to || !isDate(this.date_from) || !isDate(this.date_to))) {
			// 	this.$toast.error('Invalid search date without item');
			// 	return;
			// }

			// if (!this.item_id) {
			// 	var date_from = toDate(this.date_from);
			// 	var date_to = toDate(this.date_to);
			// 	//console.log(date_from, date_to, 'hmmm:', dateDiff(date_from, date_to));
			// 	if (dateDiff(date_from, date_to) > 365) {
			// 		this.$toast.error('Maximum search period without item is 365 days');
			// 		return;
			// 	}
			// }

			if (this.item_id && !this.selectItem()) return;

			const { data } = await apiSelectInventoryHistoryList({
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,

				item_id: this.item_id,
				date_from: this.date_from,
				date_to: this.date_to,
				adjust_reason: this.adjust_reason,
			});

			//console.log(data);

			this.histories = data.inventoryHistoryList;
			//console.log(this.histories);
			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/report/repacking?item_id=' + this.item_id;
			if (this.date_from) uri += '&date_from=' + this.date_from;
			if (this.date_to) uri += '&date_to=' + this.date_to;
			/////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			//window.history.pushState({}, null, uri);
			//console.log(uri);
		},
		async selectItem() {
			const { data } = await apiSelectItem({
				item_id: this.item_id,
			});
			//console.log(data);
			if (data.item) {
				this.item_name = data.item.name;
				this.item_code = data.item.item_code;
				this.class_code = data.item.class_code;
				this.color_code = data.item.color_code;
				return true;
			}

			this.$toast.error('Item Not Found');
			return false;
		},
		async index() {
			//const { data } = await apiIndex();
			//this.salesGroups = data.salesGroupList;
			//this.states = data.stateList;
		},
		async init() {
			//await this.index();
			if (this.$route.query.item_id) this.item_id = this.$route.query.item_id;
			if (this.$route.query.date_from) this.date_from = this.$route.query.date_from;
			if (this.$route.query.date_to) this.date_to = this.$route.query.date_to;

			if (this.item_id) await this.selectInventoryHistories(this.$route.query.page_no);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_repacking');
		this.$store.commit('setSubTitle', 'Item -> Inventory Adjustment Report for Repacking');

		this.init();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
